import React from "react";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import { AppShell } from "@/components/AppShell";
import { LayoutDashboard, Building2, Send, ScrollText, Receipt, Activity } from "lucide-react";
import PlatformDashboard from "./PlatformDashboard";
import TenantsList from "./TenantsList";
import TenantNew from "./TenantNew";
import TenantDetail from "./TenantDetail";
import PlatformMessages from "./PlatformMessages";
import SaasBillingModule from "./SaasBillingModule";
import JobStatusModule from "./JobStatusModule";

const sections = [
  {
    label: "Platform",
    items: [
      { to: "/platform", end: true, label: "Dashboard", icon: <LayoutDashboard size={16} />, testId: "nav-platform-dashboard" },
      { to: "/platform/tenants", label: "Tenants", icon: <Building2 size={16} />, testId: "nav-platform-tenants" },
      { to: "/platform/saas", label: "SaaS Billing", icon: <Receipt size={16} />, testId: "nav-platform-saas" },
      { to: "/platform/jobs", label: "Job Status", icon: <Activity size={16} />, testId: "nav-platform-jobs" },
      { to: "/platform/messages", label: "Messages", icon: <Send size={16} />, testId: "nav-platform-messages" },
    ],
  },
];

export default function PlatformLayout() {
  return (
    <AppShell
      brand={{ title: "TruckStop SaaS", subtitle: "Platform Console" }}
      sections={sections}
      testIdPrefix="platform"
    >
      <Routes>
        <Route index element={<PlatformDashboard />} />
        <Route path="tenants" element={<TenantsList />} />
        <Route path="tenants/new" element={<TenantNew />} />
        <Route path="tenants/:id" element={<TenantDetail />} />
        <Route path="messages" element={<PlatformMessages />} />
        <Route path="saas/*" element={<SaasBillingModule />} />
        <Route path="jobs" element={<JobStatusModule />} />
        <Route path="*" element={<Navigate to="/platform" replace />} />
      </Routes>
    </AppShell>
  );
}
